<template>
  <dd-input
      :title="title"
      :name="name"
      :data-dusk="dataDusk"
      :rules="rules"
      placeholder="1234 AB"
      :maxlength="7"
      v-model="postalCode"/>
</template>

<script>
import propertyApi from '~/api/property';
import _ from "lodash";
export default {
  name: "PostalCodeInput.vue",
  emits: ['postal-code', 'input'],
  props: {
    dataDusk: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
  },

  computed:{
    postalCode: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('postal-code', value);
      }
    },
  },
  methods: {

  }
};
</script>

<style scoped>

</style>
